import "../css/index.css";

// ============================================
// モジュール読み込み
// ============================================
import initCommonScript from "./libs/common";
import initAnimationScript from "./libs/animation";

// 共通script
initCommonScript();

// アニメーション
initAnimationScript();
